import React from 'react';
import { EditWhatsAppSettings } from './components/EditWhatsAppSettings';

type WhatsAppSettingsPageProps = {
  orderPageIdOverride?: string;
};

export const WhatsAppSettingsPage = ({ orderPageIdOverride }: WhatsAppSettingsPageProps) => (
  <EditWhatsAppSettings orderPageIdOverride={orderPageIdOverride} />
);
